import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "../axios";
import { setSpecialDates } from "../utils/dayType";

// 特別日を API から読み込み、差し替わったら購読側を再描画させる。
//
// getDayType() はレンダー中に同期的に呼ばれるので、非同期にはできない。
// そこで dayType.js のモジュール内の値を差し替えたうえで、ここで持っている
// バージョンを 1 進めて、購読しているコンポーネントを描き直させる。
//
// 使う側は useDayTypeVersion() を呼ぶだけでよい（戻り値は使わない）。
const DayTypeContext = createContext(0);

export const useDayTypeVersion = () => useContext(DayTypeContext);

export default function DayTypeProvider({ children }) {
  const [version, setVersion] = useState(0);

  useEffect(() => {
    let cancelled = false;

    axios
      .get("/day-types/special")
      .then((res) => {
        if (cancelled) return;
        // 同梱のフォールバックと同じ内容なら描き直さない
        if (setSpecialDates(res.data)) setVersion((v) => v + 1);
      })
      .catch(() => {
        // 取れなければ dayType.js の初期値のまま動かす
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return <DayTypeContext.Provider value={version}>{children}</DayTypeContext.Provider>;
}
